export default function getTileGraphEdgeListSizeFromWidthHeight(
  width: number,
  height: number,
): number {
  const horizontalEdgeCount = width * (height + 1)
  const verticalEdgeCount = (width + 1) * height
  const len = horizontalEdgeCount + verticalEdgeCount
  return len
}
